var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSiderOpen = function SvgSiderOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14.8,
    height: 14.8,
    x: 0.6,
    y: 0.6,
    stroke: "currentColor",
    strokeWidth: 1.2,
    rx: 2.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 8,
    x: 3.5,
    y: 4,
    fill: "currentColor",
    rx: 0.6
  })));
};
export default SvgSiderOpen;